import { connect } from 'react-redux';

import { NewobjectsLoadable } from './NewobjectsLoadable';
import { IAppState } from '../../../common/state';

export const NewobjectsContainer = connect((state: IAppState) => ({
  similarNewobjects: state.similarNewobjects,
}))(NewobjectsLoadable);
